module.exports = __webpack_public_path__ + "static/assets/4734f3fe917e80ae53b9f1f4e3d62147.mp3";